/**
 * @module plugins/vue-extends
 */
import Vue from 'vue'
import {
  EasyCard,
  SceneCard,
  GameCard,
  LongCard,
  VideoCard,
  LightCard,
  Tooltip
} from '@eqxiu/eqx-mall-ui'
import { Message, MessageBox, Button } from '@eqxiu/eqx-max-ui'
import '@eqxiu/eqx-max-ui/lib/theme/index.css'
import { VueMasonryPlugin } from '../directives/vue-masonry'
import Loading from '../components/Loading/index'

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

const eventBus = {
  install (Vue) {
    Vue.prototype.$bus = new Vue()
  }
}
Vue.use(eventBus)

Vue.use(VueMasonryPlugin)
// components
Vue.use(EasyCard)
Vue.use(SceneCard)
Vue.use(GameCard)
Vue.use(LongCard)
Vue.use(VideoCard)
Vue.use(LightCard)
Vue.use(Button)
Vue.use(Tooltip)
Vue.$message = Vue.prototype.$message = Message
Vue.$msgbox = Vue.prototype.$msgbox = MessageBox
Vue.$alert = Vue.prototype.$alert = MessageBox.alert
Vue.$confirm = Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$loading = Loading.install
